import { useState } from "react";
//--------------------------------------------------------------------------------------------
import TransitionWidthHeight from "src/components/common/TransitionWidthHeight";
import UserInfo from "src/components/common/userInfo";
import { useMyStore } from "src/components/main/mainStore";
import { 
    myAxios, MyFormData, scroll
} from "src/components/common/functions";
import DayOffForm from "./dayOffsForm";

const title = "DayOffs";
//--------------------------------------------------------------------------------------------
export default function Detail({  
    setDayOffs, 
    dayOff, 
    history, 
    editDayOff, 
    id, idid, 
    handleSubmit, 
    usersList
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const [comments, setComments] = useState("");
    const notifyDayOff = async e => {
        if(!window.confirm("Are you sure to notify the approver?")) return;
        const dayOffHashKey = e.currentTarget.id;
        const formData = new MyFormData();
        formData.append("dayOffHashKey", dayOffHashKey);
        //-------------------------------------------------------------------
        setShowLoader(true);
        const res = await myAxios("/dayOffs/notify.php", formData);
        setShowLoader(false);
        if(!res) return;
        //-------------------------------------------------------------------
        setDayOffs(dayOffs => dayOffs.map(dayOff => dayOff.dayOffHashKey === dayOffHashKey?{
            ...dayOff, 
            notify: res.data
        }:dayOff));
        history.replace(`/${title}`);
        scroll(null);
    }
    const voidDayOff = async e => {
        if(!window.confirm("Are you sure to void this absence request")) return;
        const dayOffHashKey = e.currentTarget.id;
        let voidReason = window.prompt("reason to void:");
        if(voidReason === null) return;
        while(voidReason === ""){
            window.alert("Reason is required to void.");
            voidReason = window.prompt("reason to void:");
            if(voidReason === null) return;
        }
        const formData = new MyFormData();
        formData.append("dayOffHashKey", dayOffHashKey);
        formData.append("voidReason", voidReason);
        //-------------------------------------------------------------------
        setShowLoader(true);
        const res = await myAxios("dayOffs/voidDayOff.php", formData);
        setShowLoader(false);
        if(!res) return;
        //-------------------------------------------------------------------
        setDayOffs(dayOffs => dayOffs.map(dayOff => dayOff.dayOffHashKey === dayOffHashKey?{
            ...dayOff, 
            void: "yes",
            voidReason
        }:dayOff));
        history.replace(`/${title}`);
        scroll(null);
    }
    //--------------------------------------------------------------------------------------------
    return(
        <TransitionWidthHeight 
        classNames = "cssTDTransition"
        In = {
            [
                dayOff.requesterEmail, 
                dayOff.approverEmail, 
                dayOff.submitterEmail, 
                dayOff.updaterEmail
            ].includes(user.email) && 
            history.location.pathname.split("/")[2] ===  dayOff.dayOffHashKey
        }
    >
    <div className = "border" style = {{borderRadius: "6px"}}>
        <div style = {{display: "flex"}}>
            <div className = "col-6">
                <table className = "table table-responsive-xl noTopBorder">
                    <tbody>
                        <tr>
                            <th>Submitter</th>
                            <td>
                                <UserInfo 
                                    name = {dayOff.submitter}
                                    email = {dayOff.submitterEmail}
                                />
                                <span className = "ml-3">{dayOff.submitTime}</span>
                            </td>
                        </tr>
                        {dayOff.updaterEmail?
                        <tr>
                            <th>Updater</th>
                            <td>
                                <UserInfo 
                                    name = {dayOff.updater}
                                    email = {dayOff.updaterEmail}
                                />
                                <span className = "ml-3">{dayOff.dateUpdated}</span>
                            </td>
                        </tr>
                        :null}
                        <tr>
                            <th>Notes</th>
                            <td style = {{whiteSpace: "pre-wrap"}}>{dayOff.notes}</td>
                        </tr>
                        {dayOff.notify?
                        <tr>
                            <th>Notified at</th>
                            <td>{dayOff.notify}</td>
                        </tr>
                        :<></>}
                        {dayOff.void === "yes"?
                        <tr>
                            <th>Void Reason</th>
                            <td>{dayOff.voidReason}</td>
                        </tr>
                        :<></>}
                    </tbody>
                </table>
            </div>
            <div className = "col-6">
                <table className = "table table-responsive-xl noTopBorder">
                <colgroup>
                    <col/>
                </colgroup>
                    <tbody>
                        <tr>
                            <th>Review Time</th>
                            <th>{dayOff.approvalTime}</th>
                        </tr>
                        <tr>
                            <th>Approver Comments</th>
                            <th style = {{whiteSpace: "pre-wrap"}}>{dayOff.approverNotes}</th>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        {dayOff.void === "yes"?null:<div className = "text-right mb-3">
            <span className = "btn btn-danger mx-3" onClick = {voidDayOff} id = {dayOff.dayOffHashKey}>Void</span>
            <span className = "btn btn-primary mx-3" onClick = {editDayOff}>Edit</span>
            <span className = "btn btn-info mx-3" id = {dayOff.dayOffHashKey} onClick = {notifyDayOff}>Notify</span>
        </div>}
        {dayOff.void !== "yes" && dayOff.approverEmail === user.email && dayOff.status !== "Approved" && dayOff.status !== "Rejected"?<>
        <div className = "mx-3 mb-3 font-weight-bold">Approver Comments</div>
        <textarea className = "form-control mx-3" rows = {4} style = {{minWidth: 300, width: "20%"}} value = {comments} onChange = {e => {setComments(e.currentTarget.value)}} name = "comments"/>
        <div>
            {[
                {title:"Approve", decision:"Approved", word: "approve", color: "btn-success"}, 
                {title:"Reject", decision:"Rejected", word: "reject", color: "btn-danger"}
            ].map((d, di) => 
            <span key = {di} className = {`btn ${d.color} m-3`} onClick = {async() => {
                if(d.word === "reject" && !comments){
                    window.alert("Comments are required for rejection.");
                    return;
                }
                if(!window.confirm(`Are you sure to ${d.word} this absence request?`)) return;
                const formData = new MyFormData();
                formData.append("dayOffHashKey", dayOff.dayOffHashKey);
                formData.append("approverDecision", d.decision);
                formData.append("approverNotes", comments);
                //-------------------------------------------------------------------
                setShowLoader(true);
                const res = await myAxios("dayOffs/approval.php", formData);
                setShowLoader(false);
                if(!res) return;
                //-------------------------------------------------------------------
                setDayOffs(dayOffs => dayOffs.map(dO => dO.dayOffHashKey === dayOff.dayOffHashKey?{
                    ...dO, 
                    approverNotes: comments,
                    status: d.decision
                }:dO));
            }}>{d.title}</span>)}
        </div>
        </>:null}
    </div>
    {idid === "Edit"?
    <DayOffForm 
        {...dayOff} 
        usersList = {usersList} 
        handleSubmit = {handleSubmit} 
        closeIt = {() => history.push(`/${title}/${id}`)} keyword = "Update"
    />:null}
    </TransitionWidthHeight>
    )
}